import { render } from "./PushAllCustomer.vue?vue&type=template&id=5444bf2b&scoped=true&ts=true"
import script from "./PushAllCustomer.vue?vue&type=script&lang=ts"
export * from "./PushAllCustomer.vue?vue&type=script&lang=ts"

import "./PushAllCustomer.vue?vue&type=style&index=0&id=5444bf2b&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5444bf2b"]])

export default __exports__